import { render, staticRenderFns } from "./ModuleContainer.vue?vue&type=template&id=27c5cf67&"
import script from "./ModuleContainer.vue?vue&type=script&lang=js&"
export * from "./ModuleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports